import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { OrganisationService } from '@principle-theorem/ng-principle-shared';
import { AbstractResolver } from '@principle-theorem/ng-shared';
import { CustomReport, ReportRun } from '@principle-theorem/principle-core';
import { type IReportRun } from '@principle-theorem/principle-core/interfaces';
import {
  doc,
  filterUndefined,
  getDoc$,
  type WithRef,
} from '@principle-theorem/shared';
import { type Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class ReportRunResolverService extends AbstractResolver<
  WithRef<IReportRun>
> {
  protected override idKey = 'runId';

  constructor(
    router: Router,
    private _organisation: OrganisationService
  ) {
    super(router);
  }

  getItemById(
    runId: string,
    route: ActivatedRouteSnapshot
  ): Observable<WithRef<IReportRun> | undefined> {
    const customReportUid = route.paramMap.get('uid');
    if (!customReportUid) {
      return of(undefined);
    }

    return this._organisation.brand$.pipe(
      filterUndefined(),
      switchMap((brand) => {
        const customReportRef = doc(CustomReport.col(brand), customReportUid);
        return getDoc$(ReportRun.col({ ref: customReportRef }), runId);
      })
    );
  }
}
